import TextField from "@mui/material/TextField";
import React from "react";

const Textarea = React.forwardRef((props, ref) => (
    <TextField
        inputRef={ref}
        multiline
        fullWidth
        minRows={3}
        InputProps={{ className: "check-in__mui-textarea" }}
        {...props}
    />
));

export default Textarea;
